/** The Keystone mark: a shield with a keystone notch. */
export function Mark({ size = 28 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true" focusable="false">
      <path
        d="M16 2.5 28 8v9.5c0 6.6-4.9 11-12 12.5C8.9 28.5 4 24.1 4 17.5V8z"
        fill="none"
        stroke="var(--accent)"
        strokeWidth="2.2"
        strokeLinejoin="round"
      />
      <path d="M16 11.5v9M11.5 16h9" stroke="var(--accent)" strokeWidth="2.2" strokeLinecap="round" />
    </svg>
  );
}
